import { ZfPill, ZfStack, ZfTypography } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
    years: number[];
    birthYear?: number;
    todayLeft?: number;
}

export const TimelineBar: FunctionComponent<IProps> = ({ years, birthYear, todayLeft }) => {
    const { t } = useTranslation();

    return (
        <ZfStack direction="row" alignment="stretch" className="event-timeline__bar">
            {years.map((year) => (
                <ZfStack direction="column" alignment="center" spacing="extra-extra-small" className="event-timeline__year" key={year}>
                    {birthYear != null && (
                        <ZfTypography variant="label-extra-small" color="muted">
                            {`${year - birthYear} y.o`}
                        </ZfTypography>
                    )}
                    <ZfTypography variant="body-medium" weight="bold" color="normal">
                        {year}
                    </ZfTypography>
                    <span className="event-timeline__year-dot" />
                </ZfStack>
            ))}
            {todayLeft != null && (
                <ZfPill variant="solid" color="primary" size="medium" className="event-timeline__today-label" style={{ left: `${todayLeft}px` }}>
                    {t('timelineToday')}
                </ZfPill>
            )}
        </ZfStack>
    );
};
